(function () {
  const STORAGE_KEY = 'scart_configurator_entry';

  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href]');
    if (!link) return;

    let destination;
    try { destination = new URL(link.href, window.location.href); } catch (error) { return; }
    if (destination.origin !== window.location.origin || !/\/pages\/configurateur$/.test(destination.pathname)) return;

    const sourcePath = window.location.pathname;
    let placement = link.dataset.cfgPlacement || destination.searchParams.get('cfg_place');
    if (!placement) {
      const declared = destination.searchParams.get('cfg_from');
      if (declared === 'hub_911' || declared === 'range_hub' || declared === 'sound_library') placement = declared;
      else if (link.closest('.header-wrapper, .section-header, .menu-drawer')) placement = 'header';
      else if (link.closest('.collection-find-banner')) placement = 'collection_banner';
      else if (link.closest('.pcv')) placement = 'pdp_compat';
      else if (link.closest('.product-not-your-car')) placement = 'pdp_fallback';
      else if (link.closest('.find-promo')) placement = 'home_promo';
      else if (/\/collections\//.test(sourcePath)) placement = 'collection_editorial';
      else if (/\/products\//.test(sourcePath)) placement = 'pdp_other';
      else if (/\/pages\/sound-library$/.test(sourcePath)) placement = 'sound_library';
      else if (sourcePath === '/' || /^\/(?:[a-z]{2}(?:-[a-z]{2})?)\/?$/i.test(sourcePath)) placement = 'home_other';
      else placement = 'other';
    }

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ placement: placement, path: destination.pathname, at: Date.now() }));
    } catch (error) {}

    const payload = { entry_placement: placement };
    if (typeof window.gtag === 'function') {
      try { window.gtag('event', 'configurator_entry_click', payload); } catch (error) {}
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: 'configurator_entry_click' }, payload));
    }
  }, true);
})();
